import ErrorPage from './default';
import {
  WRONG_ZONE_MIMOVISTAR_NO_CLIENTE,
  getUrlParamsAndChangeZone,
} from './constants';

function WrongZoneMiMovistarNoCliente(props) {
  const errorInfo = WRONG_ZONE_MIMOVISTAR_NO_CLIENTE(
    getUrlParamsAndChangeZone()
  );
  return (
    <ErrorPage
      {...props}
      title={errorInfo.TITLE}
      description={errorInfo.DESCRIPTION}
      buttonHref={errorInfo.BUTTON_HREF}
      buttonText={errorInfo.BUTTON_TEXT}
      iconColor="BLUE"
      iconId="informacion"
      showLink={false}
    />
  );
}
export default WrongZoneMiMovistarNoCliente;
